module.exports = __webpack_public_path__ + "img/img-backup.56da853d.png";